import {ThemeIconKey} from 'platform/foundation';

import {OptionType} from '../../types/FormControlProps';

export type CheckboxOption = {
  isDisabled?: boolean;
  checkedIcon?: ThemeIconKey;
} & OptionType<string>;

export interface CheckboxPropsBase {
  checkedIcon?: ThemeIconKey;
}
